export default "<div class=\"eqp-splash-screen\" *ngIf=\"isLoading | async\">\n    <div id=\"loader\"></div>\n</div>\n"